import car from './assets/car.svg'
import logo from './assets/logo.svg'
import house from './assets/house.svg'
import book from './assets/book.svg'

export const cards = [
  {
    className: 'large',
    image: car,
    text: '<p>1 Carro por semana</p>'
  },
  {
    className: 'large',
    image: house,
    text: '<p>1 Casa por mês</p>'
  },
  {
    className: 'small',
    image: logo,
    text: '<p>1 desejo pessoal no <strong>Sabadão de TODOS</strong></p>'
  },
  {
    className: 'small',
    image: book,
    text: '<p>Plataforma de <strong>livros digitais</strong></p>'
  }
]
